import { instance } from '@/services/avik-api-gateway'
// import { v4 as uuidv4 } from 'uuid'

export interface LeftPanelRoute {
  stopLong: string
  stopShort: string
  trackCount: number
  distance: number
}

export const getLeftPanelTrainSearch = (payload: {
  trainId: string
  departureDate: string
}): Promise<LeftPanelRoute[]> =>
  instance
    .get<LeftPanelRoute[]>(
      `/graph/train-search/left-panel?trainId=${payload.trainId}&departureDate=${payload.departureDate}`
    )
    .then((x) => x.data)

export const getLeftPanelPlaceSearch = (payload: {
  from: string
  to: string
  via?: string[]
}): Promise<LeftPanelRoute[]> =>
  instance
    .get<LeftPanelRoute[]>(`/graph/place-search/left-panel`, {
      params: {
        ...payload,
        ...(payload.via && payload.via.length
          ? { via: payload.via.join(',') }
          : {}),
      },
    })
    .then((x) => x.data)
